/**
 * The lens: each lens adds a layer of information to the facts and asks one question of them;
 * values never move. Its switch sits on the right of the facts' title line.
 */

import { useTranslation } from 'react-i18next';
import { Segmented } from '@bn-apps/dim-ui-react';
import type { Lens } from '../widgets/types';

// Lineage and time wait until there is data for them; the triples are a view of their own in the side menu
export const LENSES: Lens[] = ['default', 'shape', 'quality', 'rinf'];

/** The lens choice, as a compact switch on the facts' title line. */
export const LensSwitch = ({ lens, onChange }: { lens: Lens; onChange: (lens: Lens) => void }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Segmented
      label={t('entity.template.lens.label')}
      hideLabel
      size="sm"
      value={lens}
      onChange={onChange}
      options={LENSES.map((option) => ({
        value: option,
        label: <span title={t(`entity.template.lens.${option}.hint`)}>{t(`entity.template.lens.${option}.name`)}</span>,
      }))}
    />
  );
};
